import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => <FormattedMessage id="collection.artists" defaultMessage="Artists" />;
